import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@/shared/ui-components/button/button.component';
import { AskQuestionDialogComponent } from '../ask-question-dialog/ask-question-dialog.component';
import { QuestionsService } from '../../questions.service';

/**
 * Floating "Ask a Question" launcher shown on every authenticated page. It opens the same
 * modal the Questions page uses, so there is only one raise flow to maintain.
 */
@Component({
    selector: 'app-talk-to-us-widget',
    standalone: true,
    imports: [CommonModule, TranslateModule, ButtonComponent, AskQuestionDialogComponent],
    templateUrl: './talk-to-us-widget.component.html'
})
export class TalkToUsWidgetComponent {
    public readonly showDialog = signal<boolean>(false);

    private readonly _router = inject(Router);
    private readonly _questionsService = inject(QuestionsService);

    private readonly _currentUrl = toSignal(
        this._router.events.pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            map((event) => event.urlAfterRedirects)
        ),
        { initialValue: this._router.url }
    );

    public readonly showLauncher = computed(() => this._questionsService.canRaiseQuestions() && !this._currentUrl().split('?')[0].startsWith('/questions'));

    public open(): void {
        this.showDialog.set(true);
    }
}
